<div class="size">
  <div class="size_item">
    <b>L </b>
    <span>{{ data.Length }}</span>
  </div>
  <div class="size_item">
    <b>W </b>
    <span>{{ data.Width }}</span>
  </div>
  <div class="size_item">
    <b>H </b>
    <span>{{ data.Height }}</span>
  </div>
  <div class="size_item">
    <b>Weight </b>
    <span>{{ data.Weight }}</span>
  </div>

 <div class="edit-size" *ngIf="params.isEdit"> <i class='fal fa-edit' (click)="edit()"></i></div>
</div>